import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory();

// A page shown inside a report pop-up runs in its own in-memory history. Pages (and hooks) that call this shared
// history directly (push, replace, listen, block) must then act on that in-memory history, never on the browser URL,
// so the report underneath stays mounted. Listeners added before the pop-up opened stay on the browser history.
let override = null;
const current = () => override || browserHistory;

const history = {
  get action() { return current().action; },
  get location() { return current().location; },
  createHref: to => current().createHref(to),
  push: (...args) => current().push(...args),
  replace: (...args) => current().replace(...args),
  go: delta => current().go(delta),
  back: () => current().back(),
  forward: () => current().forward(),
  listen: listener => current().listen(listener),
  block: blocker => current().block(blocker),
  // The real browser history, used when a pop-up has to hand a navigation back to the app.
  browser: browserHistory,
  useOverride: next => {
    override = next;
    return () => { if (override === next) override = null; };
  },
};

export default history;
